import { useSnackbar } from '@e3dc-react/shell/Hooks/Snackbar'
import { ShopFetchError } from '../types/shop-api'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

interface UseShopApiErrorsHook {
  shopApiErrorSnackbar: (error: ShopFetchError) => void
}

const useShopApiError = (): UseShopApiErrorsHook => {
  const { enqueueErrorStack } = useSnackbar()
  const { t } = useCustomTranslation()

  const shopApiErrorSnackbar = (error: ShopFetchError | null): void => {
    error?.errors.map(error => enqueueErrorStack(t(error.detail)))
  }
  return { shopApiErrorSnackbar }
}

export default useShopApiError
